import * as yup from "yup";

export const RESIDUAL_VALUE_STEP1_SCHEMA = yup.object().shape({
  jom: yup.string().required("JOM broj je obavezan podatak"),
  firstRegistrationDate: yup.date().nullable().when("usedVehicle", {
    is: true,
    then: (schema) => schema.required("Datum prve registracije je obavezan za rabljena vozila"),
  }),
  mileageKm: yup.number().nullable().when("usedVehicle", {
    is: true,
    then: (schema) => schema.required("Broj prijeđenih kilometara je obavezan za rabljena vozila"),
  }),
});

export const NEW_PRICE_STEP1_SCHEMA = yup.object().shape({
  jom: yup.string().required("JOM broj je obavezan podatak"),
});

export const USED_PRICE_STEP1_SCHEMA = yup.object().shape({
  jom: yup.string().required("JOM broj je obavezan podatak"),
  firstRegistrationDate: yup.date().nullable().required("Datum prve registracije je obavezan podatak"),
  mileageKm: yup.number().nullable().required("Broj prijeđenih kilometara je obavezan podatak"),
});
